import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Container } from './Section';
import { navigation, serviceNav, site } from '../data/site';
import { Icon } from '../lib/icons';

export function Footer() {
  return (
    <footer className="border-t border-brand-border bg-brand-dark text-white">
      <Container className="py-14">
        <div className="grid gap-10 lg:grid-cols-[1.35fr_.8fr_.8fr_.9fr]">
          <div>
            <Link to="/" aria-label="MaytoMation home" className="inline-flex rounded-md bg-white px-3 py-2">
              <Logo className="h-9" />
            </Link>
            <p className="mt-5 max-w-md text-sm leading-7 text-white/70">
              Practical software, automation, infrastructure, AI systems, managed hosting, and long-term technical
              support for businesses across Massachusetts.
            </p>
            <div className="mt-6 grid gap-3 text-sm text-white/75">
              <span className="flex items-center gap-3">
                <Icon name="mapPin" className="h-4 w-4 text-brand-teal" /> Massachusetts based
              </span>
              <span className="flex items-center gap-3">
                <Icon name="mail" className="h-4 w-4 text-brand-teal" /> {site.email}
              </span>
              <span className="flex items-center gap-3">
                <Icon name="phone" className="h-4 w-4 text-brand-teal" /> {site.phone}
              </span>
            </div>
          </div>

          <div>
            <h2 className="text-sm font-extrabold uppercase tracking-[0.14em] text-brand-teal">Company</h2>
            <div className="mt-5 grid gap-3 text-sm text-white/75">
              {navigation.map((item) => (
                <Link key={item.href} to={item.href} className="transition hover:text-white">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-sm font-extrabold uppercase tracking-[0.14em] text-brand-teal">Services</h2>
            <div className="mt-5 grid gap-3 text-sm text-white/75">
              {serviceNav.map((item) => (
                <Link key={item.href} to={item.href} className="transition hover:text-white">
                  {item.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-sm font-extrabold uppercase tracking-[0.14em] text-brand-teal">Built to Last</h2>
            <p className="mt-5 text-sm leading-7 text-white/75">
              Clear process, documented systems, supportable infrastructure, and practical engineering decisions for
              long-term business operations.
            </p>
            <Link
              to="/booking"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-brand-teal px-5 py-3 text-sm font-bold text-brand-dark transition hover:bg-brand-tealLight"
            >
              Schedule a Consultation <Icon name="arrowRight" className="h-4 w-4" />
            </Link>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/60 sm:flex-row sm:items-center sm:justify-between">
          <p>Copyright {new Date().getFullYear()} MaytoMation. All rights reserved.</p>
          <p>Software, automation, infrastructure, networking, AI systems, and managed hosting.</p>
        </div>
      </Container>
    </footer>
  );
}
